import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOTagsProps {
  title: string;
  description: string;
  keywords?: string;
  author?: string;
}

const SEOTags: React.FC<SEOTagsProps> = ({ title, description, keywords, author }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
    </Helmet>
  );
};

export default SEOTags;
